module.exports = __webpack_public_path__ + "ptc_momoro_W1.58bf34a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/momoro/parent_to_child/ptc_momoro_W1.jpg
// module id = h5uP
// module chunks = 0